import { profileEnabled } from '../../../profiles';
import { Map } from 'immutable';

export function enabledNewConflictsModal(cmdError: Map<string, any> | undefined) {
    if (!profileEnabled('prof-betslip-exclusions') || !cmdError) {
        return false;
    }

    return cmdError.get('conflicts');
}

export { openConflictingBetsDialog } from './ConflictingBetsModal';
